/**
 * @function load
 * @description this loads a cookie
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _cookie = /*#__PURE__*/ _interop_require_default(require("cookie"));
var _encoding = require("./encoding");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = function(name, request, doNotParse) {
    var cookies;
    if (typeof document !== "undefined") {
        cookies = _cookie.default.parse(document.cookie);
    } else if (request) {
        // grab cookies from the request if they pass it
        // @TODO: find out and comment exactly which servers and such these support
        if (request.cookie) {
            cookies = request.cookie;
        } else if (request.cookies) {
            cookies = request.cookies;
        } else if (request.headers && request.headers.cookie) {
            cookies = _cookie.default.parse(request.headers.cookie);
        }
    }
    if (!name) return cookies;
    return cookies && (0, _encoding.decode)(cookies[name], doNotParse);
};
